import { IMessage } from 'src/app/shared/components/message/message.component';
import { NewMessageDialogWithAdditionalFieldComponent } from './../../../shared/components/new-message-dialog-with-additional-field/new-message-dialog-with-additional-field.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from 'src/app/core/services/dialogs/dialogs.service';
import { NewMessageDialogComponent } from 'src/app/shared/components/new-message-dialog/new-message-dialog.component';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter, take, tap, takeUntil, map } from 'rxjs/operators';

import { CreateAttachedSchoolClubChapterDialogComponent } from 'src/app/shared/components/create-attached-school-club-chapter-dialog/create-attached-school-club-chapter-dialog.component';
import { ReplaySubject } from 'rxjs';
import { OrganizationFacade } from '../store/organization.facade';
import { OrganizationService } from '../store/organization.service';

@Component({
  selector: 'app-organization-groups',
  templateUrl: './organization-groups.component.html'
})
export class OrganizationGroupsComponent {
  @Input() isMy: boolean;
  @Input() term: string;
  @Input() page: number;
  @Input() groups: {
    items: null | Array<{}>;
    count: number;
    amountOfPages: number;
  };
  @Input() isOrgType: boolean;
  @Input() isSchool: boolean;
  @Input() orgName: string;

  @Output() search = new EventEmitter<string>();
  @Output() setPage = new EventEmitter<number>();
  @Output() leave = new EventEmitter<number>();
  @Output() join = new EventEmitter<number>();
  @Output() create = new EventEmitter<object>();
  destroy: ReplaySubject<any> = new ReplaySubject<any>(1);

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private organizationService: OrganizationService
  ) {}

  onSearch(searchTerm) {
    this.search.emit(searchTerm);
  }

  onSetPage(page: number) {
    this.setPage.emit(page);
  }

  onJoin(id: number) {
    this.join.emit(id);
  }

  onLeave(id: number) {
    this.leave.emit(id);
  }

  openPostDialog() {
    const dialogRef = this.dialog.open(
      NewMessageDialogWithAdditionalFieldComponent,
      {
        data: {
          contact: { name: this.orgName },
          receiverID: '',
          customTitle: 'Update and provide content for your chapters'
        }
      }
    );

    dialogRef
      .afterClosed()
      .pipe(
        takeUntil(this.destroy),
        filter(({ message, isSend }: any) => isSend && message),
        map(({ message }): any => message)
      )
      .subscribe((message: IMessage) => this.sendMessage(message));
  }
  private sendMessage(message: IMessage) {
    this.organizationService
      .addResourceAllRelatedClubs({
        description: message.text,
        foto: message.images,
        file: message.docs
      })
      .subscribe((_) => this.messageHasBeenSent());
  }

  private messageHasBeenSent() {
    this.snackBar.open('Message has been sent!', 'OK', {
      duration: 10 * 1000
    });
  }

  onNewAttachedSchoolClubOrChaterGroup = () => {
    const dialogRef = this.dialog.open(
      CreateAttachedSchoolClubChapterDialogComponent,
      {
        data: { isOrgType: this.isOrgType, orgName: this.orgName }
      }
    );

    dialogRef
      .afterClosed()
      .pipe(
        take(1),
        filter((res) => res && res.type === 'submit'),
        tap((_) => this.create.emit(_.payload))
      )
      .subscribe((_) => _);
  };
}
